<template>
  <div class="promotion-list">
    <v-list
      v-for="(promotion, index) in promotions"
      :key="index"
      dense
      class="py-0"
    >
      <v-card outlined>
        <v-list-group
          color=""
          v-model="promotion.expand"
          append-icon=""
          class="py-0 my-0"
          :ripple="false"
        >
          <template v-slot:prependIcon>
            <div>
              <v-icon>
                {{ promotion.expand ? "mdi-chevron-up" : "mdi-chevron-down" }}
              </v-icon>
            </div>
          </template>
          <template v-slot:activator>
            <v-list-item-title class="my-4">
              <div class="d-flex justify-space-between align-center">
                <div
                  class="mt-1 text-truncate"
                  :style="
                    $vuetify.breakpoint.mdAndUp
                      ? `min-width: ${getMinWidth};`
                      : ''
                  "
                >
                  <div class="d-flex flex-column" style="gap: 6x">
                    <div v-if="promotion.titulo">
                      {{
                        promotion.titulo.length > 24 &&
                        $vuetify.breakpoint.smAndDown
                          ? promotion.titulo.toUpperCase().substr(0, 24)
                          : promotion.titulo.toUpperCase()
                      }}
                    </div>
                    <div v-else>
                      {{ $t("noTitle") }}
                    </div>

                    <div style="color: #a3a3a3">
                      {{ promotion.code_promo }}
                    </div>
                  </div>

                  <div
                    v-if="
                      promotion.titulo && promotion.titulo.length > 24 &&
                        $vuetify.breakpoint.smAndDown
                    "
                  >
                    <v-spacer />
                    <div class="d-flex flex-column">
                      <div>
                        {{ promotion.titulo.toUpperCase().substr(24) }}
                      </div>
                      <div>
                        {{ promotion.code_promo }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-list-item-title>
          </template>
          <template v-slot:default>
            <v-divider />
            <v-list-item
              :class="isXsmall ? 'py-4 px-0 d-flex' : 'py-4'"
            >
              <v-list-item-content class="caption py-0">
                <v-row>
                  <!-- Bônus Ganho / Data de expiração / progress bar -->
                  <!-- :class="{ 'pr-0' : !isXsmall}" -->
                  <v-col cols="12" sm="4">
                    <div
                      :class="isXsmall ?
                        'd-flex justify-space-between px-4 mb-4' :
                          'd-flex justify-space-between mb-6'
                      "
                      style="gap: 16px;"
                    >
                      <div style="width: 50%">
                        <div class="mb-2">
                          {{ $t("bonusGained") }}
                        </div>
                        <div>
                          {{ $t("labelCurrency") }} {{ promotion.bonusGained }}
                        </div>
                      </div>
                      <div style="width: 50%">
                        <div class="mb-2">
                          {{ $t("dateExpiration") }}
                        </div>
                        <div>
                          {{ handleExpirationDate(promotion.date_expiration) }}
                        </div>
                      </div>
                    </div>

                    <div
                      :class="isXsmall ?
                        'd-flex flex-column align-center px-4' :
                          'd-flex flex-column align-center'
                      "
                    >
                      <div
                        v-if="historic || hasExpired(promotion)"
                        :class="historic || hasExpired(promotion) ? '' : 'mb-6'"
                      >
                        <v-chip
                          x-small
                          class="purple darken-2 mb-1"
                        >
                          {{ $t("expiredCampaign") }}
                        </v-chip>
                      </div>
                      <div
                        v-if="hasExpired(promotion) === false"
                        class="d-flex
                          flex-column
                          align-center
                          justify-center
                        "
                        style="width: 100%;"
                      >
                        <div class="d-flex align-center mb-2">
                          <v-chip
                            x-small
                            :color="getColorByStatus(promotion.status).color"
                          >
                            <strong>
                              {{ getColorByStatus(promotion.status).text }}
                            </strong>
                          </v-chip>
                          <span class="ml-2">
                            {{ promotion.rolloverProgress}}%
                          </span>
                        </div>
                        <v-progress-linear
                          class="mb-2"
                          :value="historic ? 100 : promotion.rolloverProgress"
                          color="primary"
                        >
                        </v-progress-linear>

                        <div class="d-flex align-center caption" v-if="!history">
                          <span
                            v-if="100 - promotion.rolloverProgress != 0"
                            class="d-flex"
                          >
                            {{
                              $t("rolloverPercentageMissing", {
                                percentageMissing: (
                                  100 - promotion.rolloverProgress
                                ).toFixed(2),
                              })
                            }}
                            <div class="ml-2">
                              <v-tooltip bottom center>
                                <template v-slot:activator="{ on }">
                                  <v-icon small v-on="on">
                                    mdi-information-outline
                                  </v-icon>
                                </template>
                                <span>{{ promotion.progressTooltip }} </span>
                              </v-tooltip>
                            </div>
                          </span>
                          <span v-else>
                            {{ $t("rolloverCompleted") }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <v-divider class="mt-4" v-if="isXsmall" />
                  </v-col>
                  
                  <!-- Valor apostado / Rollover Total -->
                  <v-col cols="12" sm="4">
                    <div
                      :class="isXsmall ?
                        'd-flex px-4' :
                        'd-flex'
                      "
                      style="gap: 16px; display: flex; justify-content: space-evenly;"
                    >
                      <div
                        class="
                          d-flex
                          flex-column
                        "
                        :style="isXsmall ? 'width: 50%' : ''"
                      >
                        <div class="mb-2">
                          {{ $t("rolloverBetValue") }}
                        </div>
                        <div>
                          {{ promotion.rollover_atual }}
                        </div>
                      </div>
                      <div
                        class="
                          d-flex
                          flex-column
                        "
                        :style="isXsmall ? 'width: 50%' : ''"
                      >
                        <div class="mb-2">
                          {{ $t("totalRollover") }}
                        </div>
                        <div>
                          {{ promotion.rollover_total }}
                        </div>
                      </div>
                    </div>
                  </v-col>

                  <!-- botões -->
                  <!-- :class="{ 'pl-0' : !isXsmall}" -->
                  <v-col cols="12" sm="4">
                    <div
                      :class="isXsmall ?
                        `d-flex px-4` :
                          `
                            d-flex
                            flex-column
                            align-end
                          `
                      "
                      :style="isXsmall ? 'gap: 16px;' :
                        ' margin-bottom: 16px'"
                    >
                      <v-btn
                        outlined
                        color="primary"
                        small
                        :block="!isXsmall"
                        class="buttonStyle  flex-shrink-1"
                        :class="isXsmall ? '' : 'mb-4'"
                        @click="seePromotionUsage(promotion)"
                      >
                        {{ $t("extract") }}
                      </v-btn>

                      <v-btn
                        outlined
                        color="primary"
                        small
                        :block="!isXsmall"
                        class="buttonStyle  flex-shrink-1"
                        :class="isXsmall ? '' : ''"
                        @click="seePromotionDetail(promotion)"
                      >
                        {{ $t("seeRules") }}
                      </v-btn>

                    </div>

                    <div
                      v-if="!history"
                      :class="isXsmall ?
                        `d-flex px-4 mt-4` :
                          `
                            d-flex
                            flex-column
                            align-end
                          `
                      "
                    >
                      <v-btn
                        v-if="!history"
                        color="primary"
                        block
                        class="buttonStyle"
                        :class="{'caption' : !isXsmall }"
                        small
                        @click="callTransferBalance(promotion)"
                        :disabled="
                          promotion.rolloverProgress != 100 || loadingTransfer
                        "
                      >
                        {{ $t("transferBalance") }}
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>
      </v-card>
    </v-list>

    <!-- dialogs de confirmação transfer balance -->
    <v-dialog v-model="confirmationDialog" max-width="600">
      <v-card>
        <v-toolbar flat>
          <v-btn icon dark @click="confirmationDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{
            $t("bonusConversionConfirmation")
          }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pb-0 pb-6 pt-4">
          <v-subheader class="overline">
            {{ $t("transfer") }}
          </v-subheader>
          <div class="pa-4 pt-0 px-6">
            {{ $t("areYouSureYouWantToConvert") }}
            <strong class="primary--text"> R$ {{ bonusBalance }} </strong>
            {{ $t("ofBonusIn") }}
            <strong class="green--text">
              R$ {{ promotion.transfer_max }}
            </strong>
            {{ $t("ofRealBalance") }}?
            {{ $t("afterTransfer") }}
          </div>
          <v-subheader class="overline">
            {{ $t("attention") }}
          </v-subheader>
          <div class="pa-4 pt-0 px-6">
            {{ $t("promotionBetsAfterTransfer") }}
          </div>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-5 pt-3">
          <div class="flex-grow-1"></div>

          <v-btn text outlined="" @click="confirmationDialog = false">
            {{ $t("BtnCancel") }}
          </v-btn>

          <v-btn
            color="primary"
            :disabled="loadingTransfer"
            @click="transferBalance()"
          >
            {{ $t("confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showAnotherConfirmationDialog" max-width="600">
      <v-card>
        <v-toolbar flat>
          <v-btn icon dark @click="showAnotherConfirmationDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            {{ $t("bonusConversionConfirmation") }}
          </v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pb-0 pb-6 pt-4">
          <v-subheader class="overline">
            {{ $t("transfer") }}
          </v-subheader>
          <div class="pa-4 pt-0 px-6">
            {{ $t("areYouSureYouWantToConvert") }}
            <strong class="green--text"> R$ {{ bonusBalance }} </strong>
            {{ $t("toRealBalance") }}?
            {{ $t("afterTransferAnotherDialog") }}
          </div>
          <v-subheader class="overline">
            {{ $t("attention") }}
          </v-subheader>
          <div class="pa-4 pt-0 px-6">
            {{ $t("promotionBetsAfterTransfer") }}
          </div>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-5 pt-3">
          <div class="flex-grow-1"></div>

          <v-btn
            text
            outlined=""
            @click="showAnotherConfirmationDialog = false"
          >
            {{ $t("BtnCancel") }}
          </v-btn>

          <v-btn
            color="primary"
            :disabled="loadingTransfer"
            @click="confirmTransferInsideConfirmationDialog"
          >
            {{ $t("confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END - dialogs de confirmação transfer balance -->

    <PromotionExtract
      :dialog="promotionExtractDialog"
      :promotion="currentPromotionExtract"
      @closeDialog="promotionExtractDialog = false"
    />
    <PromotionDetail
      :dialog="promotionDetailDialog"
      :promotion="currentPromotionDetail"
      @closeDialog="promotionDetailDialog = false"
    />
  </div>
</template>
<script>
import PromotionExtract from "./PromotionExtract";
import PromotionDetail from "./PromotionDetail";

export default {
  props: ["promotions", "historic", "history"],
  components: {
    PromotionExtract,
    PromotionDetail
  },

  data: () => ({
    promotion: {},
    currentPromotionExtract: {},
    currentPromotionDetail: {},
    promotionExtractDialog: false,
    promotionDetailDialog: false,
    confirmationDialog: false,
    showAnotherConfirmationDialog: false,
    loadingTransfer: false,
    /*
      promoMock: [
        {
          bonus_max: "999.99",
          code_promo: "MOCKPROMO",
          date_active: "2023-09-10 12:59:59",
          date_expiration: "2023-09-12 23:59:59",
          date_final: "2023-09-30 23:59:59",
          days_expiration: "30",
          descricao: "MOCKDESCRIPTION",
          functioning: "",
          id_promo: "551",
          promotion_id: "551",
          regras: "",
          rollover_atual: "110.00",
          rollover_total: "6000.00",
          rollover_x: "50",
          rules: "",
          status: "1",
          titulo: "MOCKTITLE",
          transfer_max: "99999.00",
          type_promo: "1ºdeposito",
          valor_bonus: "120.00",
        }
      ]
    */
  }),

  computed: {
    isXsmall() {
      return this.$vuetify.breakpoint.name == "xs";
    },

    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },

    bonusBalance() {
      return this.$store.state.cashBonus.status == "1" &&
        this.$store.state.cashBonus.value > 0
        ? this.$store.state.cashBonus.value
        : 0;
    },

    getMinWidth() {
      const breakpoint = this.$vuetify.breakpoint.name;

      if (breakpoint == "md") {
        return "20%";
      } else if (breakpoint == "lg") {
        return "30%";
      } else if (breakpoint == "xl") {
        return "20%";
      }

      return "";
    },
  },

  methods: {
    seePromotionUsage(promotion) {
      this.currentPromotionExtract = promotion;
      this.promotionExtractDialog = true;
    },

    seePromotionDetail(promotion) {
      this.currentPromotionDetail = promotion;
      this.promotionDetailDialog = true;
    },

    confirmTransferInsideConfirmationDialog() {
      this.showAnotherConfirmationDialog = false;
      this.transferBalance();
    },

    callTransferBalance(promotion) {
      this.promotion = promotion;
      if (Number(promotion.transfer_max) < Number(this.bonusBalance)) {
        this.confirmationDialog = true;
      } else {
        // Sempre antes de transferir vamos mostrar uma dialog de confirmação
        // Avisando que o usuário vai perder as apostas pendentes
        this.showAnotherConfirmationDialog = true;
        // this.transferBalance();
        // this.refreshCash();
      }
    },

    transferBalance() {
      if (this.history) {
        return;
      }

      this.loadingTransfer = true;

      this.$request
        .post("player/online/bank/transferBonusBalance", {
          idPromotion: this.promotion.id_promo,
        })
        .then((response) => {
          //Atualiza a view atual
          // this.$router.go();
          this.fetchPromotions();
          this.refreshCash();
          const color = "success";
          let msg = response.data.messages;
          this.$store.commit("setNotification", { msg, color });
        })
        .catch((error) => {
          const msg = error.response.data.messages.error;
          const color = "warning";
          this.$store.commit("setNotification", { msg, color });
        })
        .finally(() => {
          this.loadingTransfer = false;
        });
    },

    refreshCash() {
      this.$axios.get("/player/online/bank/balanceOnline").then((resp) => {
        this.$store.commit("setCash", resp.data.dados.balance);
        this.$store.commit("setBonus", {
          value: resp.data.dados.balance_bonus,
          status: resp.data.dados.balance_bonus_status,
        });
        this.$store.commit("setAvailableBalance", resp.data.dados.available_balance);
        this.$store.commit("setRestrictedBalance", resp.data.dados.restricted_balance);
      });
    },

    progressBar(endDate, claimDate) {
      let countDownDate = new Date(endDate).getTime();
      let startDate = new Date(claimDate).getTime();
      let now = new Date().getTime();
      let distanceWhole = countDownDate - startDate;
      let distanceLeft = countDownDate - now;
      let minutesLeft = Math.floor(distanceLeft / (1000 * 60));
      let minutesTotal = Math.floor(distanceWhole / (1000 * 60));
      let progress = Math.floor(
        ((minutesTotal - minutesLeft) / minutesTotal) * 100
      );
      return progress;
    },

    hasExpired(promotion) {
      const now = new Date();

      if (now >= new Date(promotion.date_expiration)) {
        return true;
      }

      return false;
    },

    daysRemaining(endDate) {
      let today = new Date();
      let lastDay = new Date(endDate);
      if (lastDay == today || lastDay < today) {
        return 0;
      } else {
        let differenceInMiliseconds = lastDay - today;
        let daysRemaining = Math.floor(
          differenceInMiliseconds / (1000 * 60 * 60 * 24)
        );
        return daysRemaining;
      }
    },

    handleExpirationDate(expirationDate) {
      if (!expirationDate) {
        return "";
      }
      return new Date(expirationDate.replace(" ", "T")).toLocaleDateString([], {
        hour: "2-digit",
        minute: "2-digit",
      }).toLowerCase();
    },

    getColorByStatus(status) {
      const colors = {
        0: { text: this.$t("inactive"), color: "blue-grey" },
        1: { text: this.$t("ativa"), color: "green" },
        2: { text: this.$t("finishedPromotion"), color: "grey darken-4" },
        3: { text: this.$t("canceled"), color: "purple darken-2" },
        4: { text: this.$t("expired"), color: "warning" },
      };

      return colors[status];
    },
  },
};
</script>
<style scoped>
.promotion-list .v-list-item__icon {
  display: flex;
  align-self: center;
}

.buttonStyle {
  border-radius: 8px;
  width: 50%;
}
</style>
